import React from "react";
import {
  DialogContent,
  TextField,
  Switch,
  FormControlLabel,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faEnvelope, faInbox, faUser } from "@fortawesome/free-solid-svg-icons";

interface FormData {
  email: string;
  firstName: string;
  lastName: string;
  receiveEmailNotifications: boolean;
  receiveContactFormEmails: boolean;
}

interface FormErrors {
  email?: string;
  firstName?: string;
  lastName?: string;
}
interface UserDialogContentProps {
  formData: FormData;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  formErrors: FormErrors;
}

interface UserDialogContentProps {
  formData: FormData;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  formErrors: FormErrors;
}

const UserDialogContent: React.FC<UserDialogContentProps> = ({
  formData,
  handleInputChange,
  formErrors,
}) => {
  return (
    <DialogContent>
      <TextField
        autoFocus
        margin="dense"
        name="email"
        label="Email Address"
        type="email"
        fullWidth
        required
        value={formData.email}
        onChange={handleInputChange}
        error={!!formErrors.email}
        helperText={formErrors.email}
        InputProps={{
          startAdornment: (
            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "8px" }} />
          ),
        }}
      />
      <TextField
        margin="dense"
        name="firstName"
        label="First Name"
        type="text"
        fullWidth
        required
        value={formData.firstName}
        onChange={handleInputChange}
        error={!!formErrors.firstName}
        helperText={formErrors.firstName}
        InputProps={{
          startAdornment: (
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
          ),
        }}
      />
      <TextField
        margin="dense"
        name="lastName"
        label="Last Name"
        type="text"
        fullWidth
        required
        value={formData.lastName}
        onChange={handleInputChange}
        InputProps={{
          startAdornment: (
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
          ),
        }}
      />
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Notification Preferences
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.receiveEmailNotifications}
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: "receiveEmailNotifications",
                      value: e.target.checked,
                    },
                  } as unknown as React.ChangeEvent<HTMLInputElement>)
                }
                name="receiveEmailNotifications"
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon icon={faBell} style={{ marginRight: "8px" }} />
                Receive Email Notifications
              </Box>
            }
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.receiveContactFormEmails}
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: "receiveContactFormEmails",
                      value: e.target.checked,
                    },
                  } as unknown as React.ChangeEvent<HTMLInputElement>)
                }
                name="receiveContactFormEmails"
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon={faInbox}
                  style={{ marginRight: "8px" }}
                />
                Receive Contact Form Submissions
              </Box>
            }
          />
        </Box>
      </Box>
    </DialogContent>
  );
};

export default UserDialogContent;
